class MainSearch extends SearchForm {
  constructor() {
    super();
    this.searchInput = this.querySelector('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (!this.searchInput) return;
    if (this.searchInput.form) {
      this.searchInput.form.addEventListener('reset', this.onFormReset.bind(this));
    }
    
    this.searchInput.addEventListener('focus', this.onInputFocus.bind(this));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      if (this.searchInput) this.searchInput.value = '';
    }
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen && this.dataset.preventScroll !== 'true') {
      const rect = this.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      if (!isVisible) {
        this.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}

customElements.define('main-search', MainSearch);